<template>
  <div class="rteao-monitor" ref="container">
    <div class="rteao-monitor_header">
      <span class="title">{{ title }}</span>

      <div class="right-button-wrap">
        <span class="now-date">{{ nowTime }}</span>
        <template v-for="item in rightButtons">
          <span
            v-if="item.show()"
            :class="['iconfont', item.icon()]"
            :key="item.name"
            :title="item.name"
            @click="item.onClick"
          ></span>
        </template>
      </div>
    </div>

    <div class="rteao-monitor_content">
      <router-view />
    </div>
  </div>
</template>

<script>
import { getPathogenTypeList } from '@/api/RTEAO';
import { mapState } from 'vuex';
import { diffObjects, formatTimestamp } from '@/utils/utils';
import { isEmpty } from '@/utils/is';
import { cloneDeep } from 'lodash';
import { List } from '@/utils/List';
import { getTimestampRange } from '@/utils/date';

export default {
  data() {
    return {
      title: 'RT-EAO 呼吸道传染病原体气溶胶监测哨点网络系统管理平台',
      nowTime: formatTimestamp(new Date().getTime()), // 实时时间
      old: null,
      pathogenList: [],
      nodeList: [],
      nodeRegionList: [],

      isInitialized: false,

      isManagePathogenMap: {},

      nodeListStateGroup: {},
      nodeRegionGroup: {},

      nodeSceneTypeList: [
        {
          label: '医院',
          value: '1'
        },
        {
          label: '学校',
          value: '2'
        },
        {
          label: '公共场所',
          value: '3'
        },
        {
          label: '交通枢纽',
          value: '4'
        },
        {
          label: '高人流场所',
          value: '5'
        }
      ],
      nodeSceneTypeGroup: {},

      nodeSceneTypeDict: {
        1: '医院',
        2: '学校',
        3: '公共场所',
        4: '交通枢纽',
        5: '高人流场所'
      },

      timeRangeDict: {
        '2year': { label: '近两年', value: '2year' },
        year: { label: '近一年', value: 'year' },
        '0.5year': { label: '近半年', value: '0.5year' },
        month: { label: '近一个月', value: 'month' },
        week: { label: '近一周', value: 'week' },
        today: { label: '近24小时', value: 'today' }
      },
      nodeStateDict: {
        0: { color: 'green', text: '正常' },
        1: { color: 'orange', text: '列管' },
        2: { color: 'yellow', text: '非列管' }
      },
      nodeRunStateList: [
        {
          text: '规划中',
          state: '0'
        },
        {
          text: '工作中',
          state: '1'
        },
        {
          text: '暂停',
          state: '2'
        }
      ],
      nodeRunStateDict: {
        0: '规划中',
        1: '工作中',
        2: '暂停'
      },
      pathogenStateDict: {
        0: '正常',
        1: '列管',
        2: '非列管'
      },
      model: {
        timeRangeFlag: '2year',
        timeRange: getTimestampRange('2year'),
        nodeList: [],
        nodeSceneTypeList: ['1', '2', '3', '4', '5'],
        nodeRunStateList: ['0', '1', '2'],
        pathogenList: [],
        nodeSceneTypeCheckAll: true,
        pathogenListCheckAll: true,
        nodeListCheckAll: true,
        nodeStateCheckAll: true
      },
      rightButtons: [
        {
          name: '全屏',
          active: false,
          icons: ['icon-quanping', 'icon-quitquanping'],
          icon() {
            return this.icons[~~this.active];
          },
          show: () => true,
          onClick: () => {
            const button = this.rightButtons[0];

            button.active = !button.active;

            if (button.active) {
              this.$refs.container.requestFullscreen();
            } else {
              document.exitFullscreen();
            }
          }
        },
        {
          name: '回到首页',
          icon: () => 'icon-home',
          show: () => {
            return this.$route.name !== 'RTEAOMonitorHome';
          },
          onClick: () => {
            this.toPage({ name: 'RTEAOMonitor' });
          }
        }
      ]
    };
  },
  computed: {
    ...mapState('socket', ['deviceTree', 'deviceIdMap'])
  },
  provide() {
    return {
      isManagePathogenMap: this.isManagePathogenMap,
      pathogenList: this.pathogenList,
      model: this.model,
      nodeList: this.nodeList,
      nodeRunStateList: this.nodeRunStateList,
      nodeRunStateDict: this.nodeRunStateDict,
      nodeListStateGroup: this.nodeListStateGroup,
      timeRangeDict: this.timeRangeDict,
      nodeRegionList: this.nodeRegionList,
      nodeRegionGroup: this.nodeRegionGroup,
      nodeSceneTypeList: this.nodeSceneTypeList,
      nodeSceneTypeGroup: this.nodeSceneTypeGroup,
      isInitializedGetter: () => this.isInitialized,
      selectAll: () => this.selectAll(),
      resetAllParams: () => this.resetAllParams()
    };
  },
  methods: {
    curDate() {
      this.nowTime = formatTimestamp(new Date().getTime());
    },
    selectAll() {
      this.model.timeRange = getTimestampRange('year');

      this.model.nodeList.splice(0, Infinity, ...this.nodeList.map(e => e.id));

      this.model.pathogenList.splice(0, Infinity, ...this.pathogenList.map(e => e.pathogenType));
    },
    resetAllParams() {
      this.selectAll();
      this.model.timeRangeFlag = '2year';
      this.model.timeRange = getTimestampRange('2year');
    },
    toPage({ name }) {
      this.$router.push({ name });
    },
    async getPathogenTypeList() {
      try {
        const res = await getPathogenTypeList();

        if (res.code !== 200) return;

        this.pathogenList.splice(0, Infinity, ...res.data);

        this.model.pathogenList.splice(0, Infinity, ...res.data.map(e => e.pathogenType));

        this.pathogenList.forEach(e => {
          this.isManagePathogenMap[e.pathogenType] = e.isMangeType == 1;
        });
      } catch (error) {
        console.log(error);
      }
    },
    modelChange(n) {
      const diffObj = diffObjects(n, this.old);

      if (isEmpty(diffObj)) return;

      Object.keys(diffObj).forEach(key => {
        const value = diffObj[key];

        if (key === 'nodeSceneTypeList') {
          const { nodeSceneTypeList, nodeList, nodeRunStateList } = this.model;

          const add = value.old.filter(e => !value.new.includes(e));
          const del = value.new.filter(e => !value.old.includes(e));

          let list = nodeList.filter(e => !del.includes(this.deviceIdMap[e].rteaoNodeType));

          list = list.concat(
            this.nodeList
              .filter(node => {
                return add.includes(node.rteaoNodeType);
              })
              .map(e => e.id)
          );

          this.model.nodeSceneTypeCheckAll = nodeSceneTypeList.length > 0;
          this.model.nodeListCheckAll = list.length > 0;

          nodeList.splice(0, Infinity, ...list);

          const stateSet = new Set(nodeList.map(e => this.deviceIdMap[e].rteaoNodeState));
          this.model.nodeStateCheckAll = stateSet.size > 0;
          nodeRunStateList.splice(0, Infinity, ...stateSet);
        } else if (key === 'nodeRunStateList') {
          const { nodeRunStateList, nodeList, nodeSceneTypeList } = this.model;

          const add = value.old.filter(e => !value.new.includes(e));
          const del = value.new.filter(e => !value.old.includes(e));

          let list = nodeList.filter(e => !del.includes(this.deviceIdMap[e].rteaoNodeState));

          list = list.concat(
            this.nodeList
              .filter(node => {
                return add.includes(node.rteaoNodeState);
              })
              .map(e => e.id)
          );

          this.model.nodeStateCheckAll = nodeRunStateList.length > 0;
          this.model.nodeListCheckAll = list.length > 0;

          nodeList.splice(0, Infinity, ...list);

          const nodeSceneTypeSet = new Set(nodeList.map(e => this.deviceIdMap[e].rteaoNodeType));
          this.model.nodeSceneTypeCheckAll = nodeSceneTypeSet.size > 0;
          nodeSceneTypeList.splice(0, Infinity, ...nodeSceneTypeSet);
        } else if (key === 'nodeList') {
          const { nodeRunStateList, nodeList, nodeSceneTypeList } = this.model;

          const stateSet = new Set(nodeList.map(e => this.deviceIdMap[e].rteaoNodeState));
          const nodeSceneTypeSet = new Set(nodeList.map(e => this.deviceIdMap[e].rteaoNodeType));

          this.model.nodeSceneTypeCheckAll = nodeSceneTypeSet.size > 0;
          this.model.nodeListCheckAll = nodeList.length > 0;
          this.model.nodeStateCheckAll = stateSet.size > 0;

          nodeRunStateList.splice(0, Infinity, ...stateSet);
          nodeSceneTypeList.splice(0, Infinity, ...nodeSceneTypeSet);
        }

        if (key === 'pathogenList') {
          this.model.pathogenListCheckAll = this.model.pathogenList.length > 0;
        }
      });

      this.old = cloneDeep(n);
    }
  },
  watch: {
    model: {
      handler: 'modelChange',
      deep: true
    }
  },
  async mounted() {
    await this.getPathogenTypeList();

    clearInterval(this.timer);
    this.timer = setInterval(this.curDate, 1000);

    document.documentElement.style.fontSize = '24px';

    const nodes = this.deviceTree[0].children;

    this.nodeList.splice(0, Infinity, ...nodes);
    this.model.nodeList.splice(0, Infinity, ...nodes.map(e => e.id));

    this.nodeRegionList.push({ name: '北京' });
    this.nodeRegionGroup['北京'] = {
      key: '北京',
      items: nodes
    };

    const nodeSceneType = new List(nodes).groupBy('rteaoNodeType');

    Object.assign(this.nodeSceneTypeGroup, nodeSceneType.value);

    Object.assign(this.nodeListStateGroup, new List(nodes).groupBy('rteaoNodeState').value);

    this.old = cloneDeep(this.model);
    this.isInitialized = true;
  },
  beforeDestroy() {
    clearInterval(this.timer);
    document.documentElement.style.fontSize = '';
  }
};
</script>

<style lang="scss">
.rteao-monitor {
  height: 100%;
  position: relative;

  --base-font-size: 0.9rem;

  --mtable-thead-fs: calc(var(--base-font-size) * 1.25);
  --mtable-tbody-fs: calc(var(--base-font-size) * 1.125);

  --mcard-header-fs: calc(var(--base-font-size) * 1.75);
  --mcard-header-height: 3rem;

  --gap: 15px;
  --sider-width: 110px;
  --sider-gap: var(--gap);
  --header-height: 80px;

  background-color: #081727;

  &_content {
    width: 100%;
    height: 100%;
    overflow: hidden;

    box-sizing: border-box;

    position: relative;
    z-index: 5;

    .custom-form-container {
      padding: 15px 15px 0 15px;
      box-sizing: border-box;
    }
  }

  &_header {
    user-select: none;
    font-family: Microsoft YaHei, 微软雅黑;
    font-weight: bold;
    font-size: calc(var(--base-font-size) * 1.55);
    color: #ffffff;
    text-align: left;
    font-style: normal;
    text-transform: none;

    background: url('/static/image/rteao-monitor/title_bg.png') 0 0 / 100% 100% no-repeat;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;

    width: 100%;
    height: var(--header-height);
    line-height: 1;

    text-align: center;

    .title {
      position: absolute;
      left: 50%;
      top: 15px;
      transform: translateX(-50%);

      width: max-content;

      line-height: 1.2;
    }

    .right-button-wrap {
      position: absolute;
      right: calc(var(--base-font-size) * 2.25);
      top: var(--gap);

      display: flex;
      gap: var(--gap);

      .now-date {
        font-size: calc(var(--base-font-size) * 1.2);
        line-height: calc(var(--base-font-size) * 1.56);
      }

      .iconfont {
        font-size: calc(var(--base-font-size) * 1.5625);

        cursor: pointer;
      }

      .icon-home {
        font-size: calc(var(--base-font-size) * 1.75);
      }
    }
  }

  .page-wrap {
    width: calc(100%);
    height: calc(100% - var(--header-height));
    padding: var(--gap);
    box-sizing: border-box;
    margin-top: var(--header-height);
  }

  .rteao-monitor-base-container {
    box-sizing: border-box;

    height: 100%;

    position: relative;

    .radio-group {
      position: absolute;
      left: 0;
      top: 0;

      .el-radio-button__inner {
        border-radius: 0 !important;
      }
    }

    .m-table {
      height: calc(100% - 80px);
    }
  }

  .el-dialog {
    border: 1px solid rgb(12, 106, 182, 0.8);

    &__headerbtn {
      font-size: 1.2rem;
    }

    &__title {
      color: #12dced;
      font-size: 1.3rem;
    }

    &__body {
      padding: 16px 16px;
    }
  }

  .el-pagination {
    font-size: 0.9rem;
    min-width: 35.5px;
    height: 1.5rem;
    line-height: 1.5rem;

    span:not([class*='suffix']) {
      font-size: 0.9rem;
      min-width: 35.5px;
      height: 1.5rem;
      line-height: 1.5rem;
    }

    .el-pager {
      li {
        font-size: 0.9rem;
        height: 1.5rem;
        line-height: 1.5rem;
        min-width: 1.5rem;
      }
    }

    button {
      font-size: 0.9rem;
      min-width: 35.5px;
      height: 1.5rem;
      line-height: 1.5rem;
    }

    .el-pagination__sizes {
      .el-input {
        width: 5rem;

        .el-input__inner {
          font-size: 0.9rem;
          padding-left: 8px;
          height: 1.5rem;
          line-height: 1.5rem;
        }
      }
    }

    .el-pagination__jump {
      .el-input {
        width: 3rem;

        &__inner {
          font-size: 0.9rem;
          height: 1.5rem;
          line-height: 1.5rem;
        }
      }
    }
  }
}
</style>
